import Loadable from 'react-loadable';
export default Loadable({
  loader: function loader() {
    return import( /* webpackChunkName: "@atlaskit-internal_conversation-assistant" */'./main');
  },
  loading: function loading() {
    return null;
  }
});